import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { EstimationState } from 'src/app/models/EstimationState';

const EDITABLE_STATES: EstimationState[] = [
  EstimationState.INCOMPLETE,
  EstimationState.COMPLETE,
  EstimationState.TO_FIX,
];

export const estimativaEditGuard: CanActivateFn = () => {
  const router = inject(Router);
  const estimateState: EstimationState | undefined =
    (window.history.state as any)?.['estimateState'];

  // No state = new estimate creation, allow through
  if (!estimateState || EDITABLE_STATES.includes(estimateState)) {
    return true;
  }

  router.navigate(['/estimativa/resultado']);
  return false;
};